import faqs from "./faqs";
import notifications from "./notifications";
import questions from "./questions";

export default { faqs, notifications, questions };
